import { z } from "zod";

export const userCardProfileSchema = z.object({
  customerId: z.string().optional(),
  firstName: z.string().min(1, "First name is required"),
  lastName: z.string().min(1, "Last name is required"),
  email: z.string().email("Please enter a valid email address"),
});

export type UserProfileFormData = z.infer<typeof userCardProfileSchema>;
